import React from "react";
import { Button } from "./ui/button";
import { Crown } from "lucide-react";
import ChromeLogo from "./ChromeLogo";

const CTAFooter = ({ onInstallClick }) => {
  return (
    <section className="py-20 bg-black relative overflow-hidden">
      {/* Background Crown Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 transform rotate-12">
          <Crown className="w-16 h-16 text-yellow-400" />
        </div>
        <div className="absolute top-20 right-20 transform -rotate-12">
          <Crown className="w-12 h-12 text-yellow-400" />
        </div>
        <div className="absolute bottom-20 left-1/4 transform rotate-45">
          <Crown className="w-20 h-20 text-yellow-400" />
        </div>
        <div className="absolute bottom-10 right-1/3 transform -rotate-45">
          <Crown className="w-14 h-14 text-yellow-400" />
        </div>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black text-yellow-400 mb-8 leading-tight">
            WRITE LIKE A BOSS. INSTALL LIKE A BOSS.
          </h2>
          
          <div className="mb-8 flex justify-center">
            <Button 
              onClick={onInstallClick}
              className="bg-yellow-400 hover:bg-yellow-500 text-black text-2xl font-black py-8 px-12 rounded-full transform hover:scale-110 transition-all duration-300 shadow-2xl hover:shadow-yellow-400/25 flex items-center gap-4"
            >
              Install Free
              <ChromeLogo size={32} />
            </Button>
          </div>
          
          <p className="text-yellow-400/80 text-lg font-medium">
            Stop apologizing. Start owning your emails.
          </p>
        </div>
      </div>

      {/* Lightning Bolt Accent */}
      <div className="absolute bottom-0 right-0 w-64 h-64 opacity-5">
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full text-yellow-400">
          <path d="M13 0L6 9h4l-1 15 7-9h-4l1-15z"/>
        </svg>
      </div>
    </section>
  );
};

export default CTAFooter;